if (window.innerWidth > 799) {
    document.addEventListener('DOMContentLoaded', () => {
      const hints = document.querySelectorAll('.hint-color');
      const colorHint = hints[0];
      const materialHint = hints[1]; // may be undefined if product has no material_label
      if (!colorHint) return;
      const originalColor = colorHint.textContent;
      const originalMaterial = materialHint ? materialHint.textContent : '';
      const containers = document.querySelectorAll('.hover-status');
      containers.forEach((container) => {
        const textColor = container.querySelector('.text-hidden');
        const textMaterial = container.querySelector('.material-hidden');
        const image = container.querySelector('img');
        if (!image) return;
        image.addEventListener('mouseenter', () => {
          if (textColor) colorHint.textContent = textColor.textContent;
          if (materialHint && textMaterial && textMaterial.textContent.trim()) {
            materialHint.textContent = textMaterial.textContent;
          }
        });
        image.addEventListener('mouseleave', () => {
          colorHint.textContent = originalColor;
          if (materialHint) materialHint.textContent = originalMaterial;
        });
      });
    });
  }
